import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import { blogs_helper } from "@/helpers/blogs_helper";
import { event_helper } from "@/helpers/event_helper";
import { podcast_helper } from "@/helpers/podcast_helper";
import BlogCard from "@/components/BlogCard";
import { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import EventPodcastSection from "@/components/EventPodcastSection";
import FormSection from "@/components/FormSection";

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination, Autoplay]);

function BlogSection({blogs}) {
  return <div className={classes.section}>
    {
      blogs.map((item, index) => {
        return <BlogCard key={index} blog={item} className={classes.blog} />
      })
    }
  </div>
}

export default function BlogsPage({title, canonical, blogs, events, podcasts}) {
  
  const breakpoints = {
    500: {
        slidesPerView: 1,
    },
    760: {
        slidesPerView: 1,
    },
    1150: {
        slidesPerView: 1,
    },
    1240: {
        slidesPerView: 1
    }
};

  const itemsPerPage = 4;
  const [filtered, setFiltered] = useState(blogs);
  const [items, setItems] = useState([]);

  const splitSections = () => {
    const sections = [];
    filtered.forEach((item, index) => {
      if(index % itemsPerPage === 0) {
        sections.push([]);
      }
      sections[sections.length - 1].push(item);
    });
    setItems(sections);
  }

  useEffect(() => {
    splitSections();
  }, [filtered]);

  const handleSearch = () => {
    const value = document.getElementById("home-input").value;
    const filtered = blogs.filter((item) => item.title.toLowerCase().includes(value.toLowerCase()));
    setFiltered(filtered);
  }

  const page = {
    title: {
      path: "blogs.hero.title",
      placeholder: "Resources Overview",
    },
    background: {
      path: "blogs.hero.image"
    },
    listSubtitle: {
      path: "blogs.listing.subtitle",
      placeholder: "Latest news",
    },
    listTitle: {
      path: "blogs.listing.description",
      placeholder: "Search our blog for more insights and updates",
    },
    formTitle: {
      path: "blogs.form.title",
      placeholder: "Subscribe now",
    }
  }

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <Hero background={page.background} title={page.title} />
      <div className={classes.search_cont}>
        <Title className={`h5 ${classes.subtitle}`} title={page.listSubtitle} tag="div" />
        <Title className={`${classes.title}`} title={page.listTitle} tag="h4" />
        <input id="home-input" className={classes.input} placeholder="Search by keywords" onKeyUp={handleSearch} />
      </div>
      <div className={classes.listings}>
          <Swiper 
            loop
            effect={"slide"}
            speed={1000}
            spaceBetween={10}
            navigation={{ prevEl: '.swiper-job-button-prev', nextEl: '.swiper-job-button-next' }} 
            breakpoints={breakpoints}>
            {
              items.map((item, index) => {
                return <SwiperSlide key={index}>
                <BlogSection key={index} blogs={item} />
              </SwiperSlide>
              })
            }
          </Swiper>
      </div>
      <div className={classes.arrow}>
          <img className={'swiper-job-button-prev'} src="/icons/round-arrow-left.svg" alt="left-arrow"></img>
          <img className={'swiper-job-button-next'} src="/icons/round-arrow-right.svg" alt="right-arrow"></img>
      </div>
      <EventPodcastSection path={"disruptive.event"} events={events} podcasts={podcasts} />
      <div id="subscribe-now">
        <h4 className={classes.formTitle}>Hear from us:</h4>
        <FormSection title={page.formTitle} variant="dark" formId="b41f1561-7b8d-41cf-ae20-2924ccf90a66" redirect_url="/thank-you" />
      </div>
    </>
  );
}

export async function getStaticProps({ }) {
  const blogs = blogs_helper.fetch();
  const events = event_helper.fetch({limit: 3});
  const podcasts = podcast_helper.fetch({limit: 3});
  return {
    props: {
      title: "Blog",
      canonical: "/blogs/",
      blogs,
      events,
      podcasts,
    },
  };
}